// Small helper around window.gtag so we can safely fire GA4 custom events.
// Usage: import { track } from "@/lib/analytics"; track("pro_plan_tokens_chosen", { source: "onboarding" });
export function track(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", eventName, params);
  } catch {
    /* swallow — analytics must never break the app */
  }
}
